/**
 * Band Style — SjImageStepper over Thinkspace's "Band Style" select.
 *
 * Thumbs: assets/band-{code}.png
 * Config:  window.__SJ_IMAGE_STEPPER_CONFIG__.bandImages
 *
 * Same strip UI as Ring Style / Seal Design (shared height token in CSS).
 *
 * Depends on: sj-3d-builder.js, sj-image-stepper.js/.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B || typeof window.SjImageStepper !== 'function') return;

  var OPTION_NAME = 'Band Style';
  var HOST_ATTR = 'data-sj-image-stepper-host';
  var ENHANCED_ATTR = 'data-sj-band-stepper-ready';

  function bandImageMap() {
    var m = B.stepperConfig().bandImages;
    return m && typeof m === 'object' ? m : {};
  }

  function readSelectOptions(select) {
    var map = bandImageMap();
    return Array.from(select.options || [])
      .filter(function (opt) {
        return !opt.disabled && String(opt.value || '').trim() !== '';
      })
      .map(function (opt) {
        var value = String(opt.value).trim();
        var label = String(opt.textContent || value).trim() || value;
        var key = value.toUpperCase();
        var imageUrl =
          map[key] || map[value] || map[value.toLowerCase()] || '';
        return { value: value, label: label, imageUrl: imageUrl };
      });
  }

  function enhanceField(field) {
    if (!field || field.getAttribute(ENHANCED_ATTR) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(ENHANCED_ATTR, '1');
    field.setAttribute(HOST_ATTR, 'band');

    var mount = document.createElement('div');
    mount.className = 'sj-image-stepper-mount';
    field.appendChild(mount);

    var stepper = new window.SjImageStepper({
      mountEl: mount,
      kind: 'band',
      layout: 'strip',
      visibleCount: 3,
      ariaLabel: 'Band Style',
      options: readSelectOptions(select),
      getValue: function () {
        return String(select.value || '');
      },
      setValue: function (value) {
        B.setSelectValue(select, value);
      },
    });

    field._sjBandStepper = stepper;

    var mo = new MutationObserver(function () {
      var next = readSelectOptions(select);
      var prevKey = stepper.options
        .map(function (o) {
          return o.value;
        })
        .join('|');
      var nextKey = next
        .map(function (o) {
          return o.value;
        })
        .join('|');
      if (prevKey !== nextKey) {
        stepper.setOptions(next);
      } else {
        // Keep strip window while shopper browses with arrows
        stepper.syncFromValue(undefined, { keepWindow: true });
      }
    });
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected'],
    });
    select.addEventListener('change', function () {
      stepper.syncFromValue(undefined, { keepWindow: false });
    });
    field._sjBandStepperMo = mo;
  }

  function scan() {
    document
      .querySelectorAll('[data-option="' + OPTION_NAME + '"]')
      .forEach(enhanceField);
  }

  B.bootOnWidget(function (widget) {
    B.watchWidget(widget, scan);
  });
})();
